/**
 * Transforms prescription dosage display for specific medicines
 * @param {string} medicineName - The medicine name
 * @param {string} dosage - The original dosage
 * @returns {string} The transformed dosage for display
 */
export const getDisplayDosage = (medicineName, dosage) => {
  // Handle Sildenafil Arousal Cream dosage transformation
  if (medicineName === 'Sildenafil Arousal Cream' && dosage === '1mg/ml') {
    return '4% (40mg/ml)';
  }

  return dosage;
};
